exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-5cc7c1ae] {\n  padding: 3%;\n  align-items: center;\n}\n.submission-form[data-v-5cc7c1ae] {\n  border: 10px solid white;\n}\n.submission-form-header[data-v-5cc7c1ae] {\n  padding: 10px;\n  background-color: #0e2547;\n  color: white;\n  text-align: center;\n}\n.submission-form-body[data-v-5cc7c1ae] {\n  padding: 10px;\n  border-top: 10px solid white;\n  background-color: #eaeaea;\n}\n.submission-form-footer[data-v-5cc7c1ae] {\n  padding: 10px;\n  text-align: center;\n  border-top: 10px solid white;\n  background-color: #0e2547;\n}\n.submit-button[data-v-5cc7c1ae] {\n  border-radius: 20px;\n}\n.error-msg[data-v-5cc7c1ae] {\n  color: red;\n  font-style: italic;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5cc7c1ae","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/submit/submitForm.vue
// module id = 1068
// module chunks = 2